import { render } from "./ReservationComponent.vue?vue&type=template&id=5800f678&scoped=true"
import script from "./ReservationComponent.vue?vue&type=script&lang=js"
export * from "./ReservationComponent.vue?vue&type=script&lang=js"

import "./ReservationComponent.vue?vue&type=style&index=0&id=5800f678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5800f678"]])

export default __exports__